import React from "react";
import styled from "styled-components";
import { SPLIT_VIEW_TYPE } from "../../../configs/constants/SplitViewType";
import TimeReportDetailsSideBar from "../../../pages/TimeReports/TimeReportDetailsSideBar";
import Button from "../../Core/Button/Button";
import Flex from "../../Layout/Flex";
import SplitViewLayout from "../../Layout/SplitVIewLayout";
import { useSplitViewStore } from "../../../stores/splitView.store";

// TODO: This seems a bit overkill? /JS
const SplitView: React.FC = () => {
	const splitViewStore = useSplitViewStore();
	const { activeSidebar } = splitViewStore;

	const renderSplitView = () => {
		switch (activeSidebar) {
			case SPLIT_VIEW_TYPE.TIME_REPORT_DETAILS:
				// Handles its own data loading (React Query)
				return <TimeReportDetailsSideBar />;
		}
	};

	return (
		<SplitViewLayout>
			<Flex justifyContent="flex-end">
				<Button
					onClick={() => splitViewStore.toggleSplitView()}
					backgroundColor="transparent"
					icon="cross"
				/>
			</Flex>

			<ContentWrapper>{renderSplitView()}</ContentWrapper>
		</SplitViewLayout>
	);
};

export default SplitView;

const ContentWrapper = styled.div`
	overflow: hidden;
`;
